document.addEventListener('DOMContentLoaded', () => {
  initBreedChooser()
  initHeaderBreedRandomizer()
})

const initBreedChooser = () => {
  document.querySelectorAll('.breed-chooser').forEach(el => {
    Object.assign(el.style, { display: 'block', padding: '10px 0 0 0', borderBottom: 'none' })
  })
  document.querySelectorAll('.breed-chooser select').forEach(el => { el.style.display = '' })
  document.querySelectorAll('.breed-chooser').forEach(el => {
    const inner = el.closest('.inner')
    if (inner) inner.style.paddingLeft = '0px'
  })
  document.querySelectorAll('.breed-chooser select').forEach(select => {
    select.addEventListener('change', function() { window.location.href = this.value })
  })
}

const initHeaderBreedRandomizer = () => {
  const breedSelectorImages = document.getElementById('header-breed-selector-images')
  if (!breedSelectorImages) return

  const imgs = breedSelectorImages.querySelectorAll('img')
  const img = imgs[Math.floor(Math.random() * imgs.length)]
  if (!img) return

  const breedName = img.getAttribute('data-breed-name')
  const selectEl = document.querySelector('#header-breed-selector .breed-chooser select')
  if (!selectEl) return

  const option = selectEl.querySelector(`option[data-breed-name="${breedName}"]`)
  if (option) option.selected = true

  setTimeout(() => {
    const link = img.closest('a')
    if (link) link.href = selectEl.value
    img.style.display = ''
    img.style.opacity = '1'
  }, 500)
}
